import React, { useEffect, useState, useCallback } from 'react';
import { Upload, Trash2, Copy } from 'lucide-react';
import { adminApi } from '../api';
import { useAuth } from '../AuthContext';

export function MediaLibrary() {
  const { isSuper, tenantId } = useAuth();
  const scope = isSuper ? tenantId : undefined;
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (isSuper && !tenantId) return;
    setItems(await adminApi.listMedia(scope));
  }, [scope, isSuper, tenantId]);
  useEffect(() => { load(); }, [load]);

  const upload = async (files) => {
    setBusy(true);
    try { for (const f of files) await adminApi.uploadMedia(f, scope); await load(); }
    catch (e) { alert('Errore: ' + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const remove = async (m) => { if (window.confirm('Eliminare immagine?')) { await adminApi.deleteMedia(m.id, scope); load(); } };
  const copy = (url) => { navigator.clipboard.writeText(url); };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div><h1 className="font-display text-3xl text-paelbi-ink">Media</h1><p className="text-paelbi-ink/60">Libreria immagini della struttura.</p></div>
        <label className="inline-flex cursor-pointer items-center gap-2 rounded-btn bg-paelbi-brown px-4 py-2.5 text-sm font-semibold text-white hover:bg-paelbi-brown-dark">
          <Upload size={16} /> {busy ? 'Carico...' : 'Carica immagini'}
          <input type="file" accept="image/*" multiple className="hidden" onChange={(e) => upload(Array.from(e.target.files))} />
        </label>
      </div>

      <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4">
        {items.map((m) => (
          <div key={m.id} className="overflow-hidden rounded-xl border border-paelbi-line bg-white">
            <img src={m.url} alt="" className="h-32 w-full object-cover" />
            <div className="flex items-center justify-between p-2">
              <button onClick={() => copy(m.url)} className="inline-flex items-center gap-1 text-xs text-paelbi-ink/60 hover:text-paelbi-brown"><Copy size={13} />URL</button>
              <button onClick={() => remove(m)} className="text-red-500 hover:text-red-600"><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="col-span-full text-sm text-paelbi-ink/50">Nessuna immagine caricata.</p>}
      </div>
    </div>
  );
}

export default MediaLibrary;
